import type { Ref } from "vue";
import type { ZodType } from "zod/v4";

import type {
  ApiSubscriber,
  ApiSubscription,
  HandlerContext,
} from "@/backend/natsstubs/wire/ApiSubscriber";
import type { Subject } from "@/backend/natsstubs/wire/context";
import type { NatsApiSubscriber } from "@/backend/natsstubs/wire/nats/NatsApiSubscriber";
import type { Param } from "@/backend/natsstubs/wire/subjectVars";
import { useStatisticsStore } from "@/store/statistics";

export class NatsApiSubscriberWrapper implements ApiSubscriber {
  constructor(
    private natsSubscriber: NatsApiSubscriber,
    private paused: Ref<boolean>,
  ) {}

  subscribe<T, P extends Record<string, Param>>(
    subject: Subject<P>,
    schema: ZodType<T>,
    callback: (payload: T, params: P, context: HandlerContext) => void,
    allowedRoles: readonly string[],
  ): ApiSubscription {
    return this.natsSubscriber.subscribe(
      subject,
      schema,
      (payload: T, params: P, context: HandlerContext) => {
        if (this.paused.value) {
          return;
        }
        useStatisticsStore().addOk("receives");
        callback(payload, params, context);
      },
      allowedRoles,
    );
  }
}
